export default {"src":"/_next/static/media/whoop-loading.dd39572d.gif","height":150,"width":150,"blurWidth":0,"blurHeight":0};